export default __webpack_public_path__ + "static/media/live-chat.f0b75f37.svg";